import { Close, Menu } from "@mui/icons-material";
import { Box, Button, Drawer, IconButton, Sheet } from "@mui/joy";
import { useState } from "react";
import { Link, useNavigate } from "react-router";

import {
  BrandWithIcon,
  ColorSchemeToggle,
  PrimaryButton,
} from "~/common/components";
import type { BrandWithIconProps } from "~/common/components/BrandWithIcon/BrandWithIcon";
import { RoutePaths } from "~/common/constants/route-paths";

export const Header = (props: {
  brandWithIconProps?: BrandWithIconProps;
  addSpacer?: boolean;
}) => {
  const { brandWithIconProps, addSpacer } = props;
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleAboutUs = () => {
    setMobileMenuOpen(false);
    void navigate(RoutePaths.ABOUT_US);
  };

  const handlePrices = () => {
    setMobileMenuOpen(false);
    void navigate(RoutePaths.PRICING);
  };

  const handleStart = () => {
    setMobileMenuOpen(false);
    void navigate(RoutePaths.PRICING);
  };

  const handleSignIn = () => {
    setMobileMenuOpen(false);
    void navigate(RoutePaths.SIGN_IN);
  };

  return (
    <>
      {/* Spacer to reserve space for fixed header */}
      {addSpacer && <Box sx={{ height: { xs: 64, sm: 72, md: 80 } }} />}

      <Box
        component="header"
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1100,
          display: "flex",
          justifyContent: "center",
          px: { xs: 2, sm: 3, md: 4, lg: 6 },
          width: "100%",
          backdropFilter: "blur(20px) saturate(180%)",
          WebkitBackdropFilter: "blur(20px) saturate(180%)",
          backgroundColor: "rgba(255, 255, 255, 0.4)",
          borderBottom: "1px solid",
          borderColor: "divider",
          "[data-joy-color-scheme='dark'] &": {
            backgroundColor: "rgba(19, 19, 24, 0.85)",
          },
        }}
      >
        <Box
          sx={{
            maxWidth: { lg: 1400, xl: 1400 },
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            py: { xs: 1.5, sm: 2 },
          }}
        >
          <Link to={RoutePaths.HOME} style={{ textDecoration: "none" }}>
            <BrandWithIcon
              iconSize={28}
              fontSize="md"
              {...brandWithIconProps}
            />
          </Link>

          {/* Desktop navigation */}
          <Box
            sx={{
              display: { xs: "none", sm: "flex" },
              gap: 1,
              alignItems: "center",
            }}
          >
            <ColorSchemeToggle />

            <Button variant="plain" color="neutral" onClick={handleAboutUs}>
              Про нас
            </Button>

            <Button variant="plain" color="neutral" onClick={handlePrices}>
              Ціни
            </Button>

            <Button variant="outlined" color="neutral" onClick={handleSignIn}>
              Увійти
            </Button>

            <Button variant="solid" color="primary" onClick={handleStart}>
              Розпочати
            </Button>
          </Box>

          {/* Mobile menu button */}
          <IconButton
            variant="plain"
            color="neutral"
            onClick={() => setMobileMenuOpen(true)}
            sx={{ display: { xs: "flex", sm: "none" } }}
          >
            <Menu />
          </IconButton>
        </Box>
      </Box>

      {/* Mobile drawer */}
      <Drawer
        anchor="right"
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
        slotProps={{
          content: {
            sx: {
              width: "100%",
              maxWidth: 300,
              backdropFilter: "blur(20px) saturate(180%)",
              WebkitBackdropFilter: "blur(20px) saturate(180%)",
              backgroundColor: "rgba(255, 255, 255, 0.85)",
              "[data-joy-color-scheme='dark'] &": {
                backgroundColor: "rgba(30, 30, 30, 0.85)",
              },
            },
          },
        }}
      >
        <Sheet sx={{ p: 2, height: "100%", backgroundColor: "transparent" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
            }}
          >
            <Link
              to={RoutePaths.HOME}
              style={{ textDecoration: "none" }}
              onClick={() => setMobileMenuOpen(false)}
            >
              <BrandWithIcon iconSize={28} fontSize="md" />
            </Link>
            <IconButton
              variant="plain"
              color="neutral"
              onClick={() => setMobileMenuOpen(false)}
            >
              <Close />
            </IconButton>
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <ColorSchemeToggle prefixText="Змінити тему" />

            <Button
              variant="plain"
              color="neutral"
              fullWidth
              onClick={handleAboutUs}
            >
              Про нас
            </Button>

            <Button
              variant="plain"
              color="neutral"
              fullWidth
              onClick={handlePrices}
            >
              Ціни
            </Button>

            <Button
              variant="outlined"
              color="neutral"
              fullWidth
              onClick={handleSignIn}
            >
              Увійти
            </Button>

            <PrimaryButton
              variant="solid"
              color="primary"
              fullWidth
              onClick={handleStart}
            >
              Розпочати
            </PrimaryButton>
          </Box>
        </Sheet>
      </Drawer>
    </>
  );
};
